/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListEstablishmentsQueryResponse, ListEstablishmentsPathParams, ListEstablishmentsQueryParams, ListEstablishments400, ListEstablishments401, ListEstablishments403, ListEstablishments404, ListEstablishments409, ListEstablishments500 } from "../../types/establishmentController/ListEstablishments.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listEstablishments } from "../../client/establishmentController/listEstablishments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listEstablishmentsQueryKey = (organizationId: ListEstablishmentsPathParams["organizationId"] | undefined, params?: ListEstablishmentsQueryParams) => [{ url: '/api/organizations/:organizationId/establishments/', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListEstablishmentsQueryKey = ReturnType<typeof listEstablishmentsQueryKey>

export function listEstablishmentsQueryOptions(organizationId: ListEstablishmentsPathParams["organizationId"] | undefined, params?: ListEstablishmentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listEstablishmentsQueryKey(organizationId, params)
        return queryOptions<ListEstablishmentsQueryResponse, ResponseErrorConfig<ListEstablishments400 | ListEstablishments401 | ListEstablishments403 | ListEstablishments404 | ListEstablishments409 | ListEstablishments500>, ListEstablishmentsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listEstablishments(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List establishments
 * {@link /api/organizations/:organizationId/establishments/}
 */
export function useListEstablishments<TData = ListEstablishmentsQueryResponse, TQueryData = ListEstablishmentsQueryResponse, TQueryKey extends QueryKey = ListEstablishmentsQueryKey>(organizationId: ListEstablishmentsPathParams["organizationId"] | undefined, params?: ListEstablishmentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListEstablishmentsQueryResponse, ResponseErrorConfig<ListEstablishments400 | ListEstablishments401 | ListEstablishments403 | ListEstablishments404 | ListEstablishments409 | ListEstablishments500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listEstablishmentsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listEstablishmentsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListEstablishments400 | ListEstablishments401 | ListEstablishments403 | ListEstablishments404 | ListEstablishments409 | ListEstablishments500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}